export const isTokenVerified = async () => {
  const expireDate = new Date(
    JSON.parse(window.localStorage.getItem('user')).expire
  );
  if (expireDate > new Date()) {
    return true;
  }
  return false;
};
